import styles from '@hts/entities/Card/styles/CardPreview/PreviewBlock.module.scss';
import Konva from 'konva';
import React, { memo, useRef } from 'react';
import { useCardContext } from '../../libs';
import { LiveView } from './LiveView';

interface PreviewBlockProps {}

export const PreviewBlock: React.FC<PreviewBlockProps> = memo(() => {
  const containerRef = useRef<HTMLDivElement>(null);
  const stageRef = useRef<Konva.Stage | null>(null);

  const activeTextFieldId = useCardContext((state) => state.activeTextFieldId);

  return (
    <div ref={containerRef} className={styles.container}>
      <LiveView ref={stageRef} containerRef={containerRef} activeTextFieldId={activeTextFieldId} />
    </div>
  );
});
